import { Avatar } from '../../atoms'
import type { ArrowPosition } from '../BubbleWithArrow'
import { BubbleWithArrow } from '../BubbleWithArrow'
import * as styles from './index.css'

export const TextMessageEntity = (props: {
  text: string
  isMine?: boolean
  showAvatar?: boolean
  userAvatarUrl?: string | null
  arrowPosition?: ArrowPosition | null
  className?: string
}) => {
  const {
    text,
    isMine,
    showAvatar = true,
    userAvatarUrl,
    arrowPosition = { vertical: 'top', horizontal: 'left' },
    className,
  } = props

  return (
    <div className={isMine ? styles.entityUser : styles.entityNotUser}>
      <div className={showAvatar ? styles.avatar : styles.avatarPlaceholder}>
        {showAvatar && (
          <Avatar
            avatar={userAvatarUrl || null}
            faceDirection={isMine ? 'left' : 'right'}
          />
        )}
      </div>

      <BubbleWithArrow
        arrowPosition={arrowPosition}
        className={className}
        variant={isMine ? 'user' : 'other'}
      >
        <div className={styles.textWrapper}>
          <div className={styles.text}>{text}</div>
        </div>
      </BubbleWithArrow>
    </div>
  )
}
